import { type AxiosError, type InternalAxiosRequestConfig } from 'axios'
import { client, getErrorMessage } from './generated'
import type { ErrorResponse } from './generated'
import { toast } from '@/shared/stores/toastStore'

// Re-export from generated.ts
export { client as default, client, getErrorMessage }

export function getAuthToken(): string | null {
  const authData = localStorage.getItem('auth-storage')
  if (!authData) return null
  try {
    const { state } = JSON.parse(authData)
    return state?.token ?? null
  } catch (err) {
    toast.error('Corrupt auth data cleared: ' + getErrorMessage(err))
    localStorage.removeItem('auth-storage')
    return null
  }
}

// --- Interceptors (non-generated, applied once at import time) ---

client.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

client.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ErrorResponse>) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth-storage')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)
